export const LOGIN_CALL = "LOGIN_CALL"
export const LOGIN_REQUEST = "LOGIN_REQUEST"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAILED = "LOGIN_FAILED"
export const CLEAR_TOKEN = "CLEAR_TOKEN"
export const AUTH0_LOGIN_CALL = "AUTH0_LOGIN_CALL"

export const loginCall = payload => ({ type: LOGIN_CALL, payload })
export const loginRequest = payload => ({ type: LOGIN_REQUEST, payload })
export const loginSuccess = payload => ({ type: LOGIN_SUCCESS, payload })
export const loginFailed = payload => ({ type: LOGIN_FAILED, payload })
export const auth0LoginCall = payload => ({ type: AUTH0_LOGIN_CALL, payload })

export const STEP = {
  EMAIL_INPUT: "EMAIL_INPUT",
  IDENTIFYING: "IDENTIFYING",
  CONTINUE_WITH_EMAIL_PASSWORD: "CONTINUE_WITH_EMAIL_PASSWORD",
  CONTINUE_WITH_FACEBOOK: "CONTINUE_WITH_FACEBOOK",
  CONTINUE_WITH_GOOGLE: "CONTINUE_WITH_GOOGLE",
  CONTINUE_WITH_SSO: "CONTINUE_WITH_SSO"
}

export const EVENT_MAIN_FEATURE_AUTHENTICATION = "authentication"
export const EVENT_MAIN_FEATURE_SIGNUP = "sign_up"
export const EVENT_MAIN_FEATURE_LOGIN = "login"
export const EVENT_SUB_FEATURE_GENERIC = "generic"
export const EVENT_SUB_PARTNER_SUBDOMAIN = "partner_subdomain"
export const EVENT_LOCATION_IDENTIFIER = "identifier"
export const EVENT_LOCATION_LANDING = "landing"
export const EVENT_LOCATION_METHOD_SUGGESTION = "method_suggestion"
export const EVENT_SIGNUP_STATE_DIRECT_LANDING = "direct_landing"
export const EVENT_LOGIN_STATE_PARTNER_DIRECT = "partner_direct"
export const EVENT_LOGIN_STATE_NEW_SESSION = "new_session"
export const EVENT_LOGIN_STATE_EXISTING_SESSION = "existing_session"
export const EVENT_LOGIN_STATE_STEP_METHOD_MAPPING = {
  [STEP.CONTINUE_WITH_GOOGLE]: "google_sso",
  [STEP.CONTINUE_WITH_FACEBOOK]: "facebook_soo",
  [STEP.CONTINUE_WITH_SSO]: "partner_sso",
  [STEP.CONTINUE_WITH_EMAIL_PASSWORD]: "email_password"
}
